import { computed, watch } from 'vue';
import { useRouterStore } from '@/store/router.store';
import { useProjectStore } from '@/store/project.store';
import { getProjectType, getProjectId, isPrivateLabel as globalIsPrivateLabel, isWhiteLabel as globalIsWhiteLabel } from '@/config/global-site-config';

export function useProjectType() {
  const routerStore = useRouterStore();
  const projectStore = useProjectStore();

  // Use the global site config as the single source of truth
  const projectType = computed(() => {
    return getProjectType();
  });

  // Sync global project ID to store when needed
  watch(projectType, async (newProjectType) => {
    if (newProjectType === 'private_label') {
      const globalProjectId = getProjectId();
      if (globalProjectId && !projectStore.projectId) {
        projectStore.setState({ key: 'projectId', value: globalProjectId });
        console.log('[useProjectType] ✅ Synced global project ID to store:', globalProjectId);
      }
    }
  }, { immediate: true });
  
  // Helper computed properties using global functions
  const isWhiteLabel = computed(() => globalIsWhiteLabel());
  const isPrivateLabel = computed(() => globalIsPrivateLabel());
  
  // Helper methods for common patterns
  const getProjectPath = (basePath: string, projectId?: string) => {
    if (isWhiteLabel.value && projectId) {
      return `/${projectId}${basePath}`;
    }
    return basePath;
  };
  
  const needsProjectId = computed(() => isWhiteLabel.value);
  
  const getBaseUrl = (projectId?: string) => {
    if (isWhiteLabel.value && projectId) {
      return `${window.location.origin}/${projectId}`;
    }
    return window.location.origin;
  };

  return {
    // Core values
    projectType,
    isWhiteLabel,
    isPrivateLabel,
    needsProjectId,
    
    // Helper methods
    getProjectPath,
    getBaseUrl,
  };
} 